<script setup lang="ts">
import { SKIP_DOM_SELECTION_TAG } from "lexical";
import { useLexicalComposer } from "lexical-vue";

import Button from "~/components/dumb/Button.vue";
import { ToggleSectionIcon } from "~/icons";
import { ButtonStyle, IconSize } from "~/shared/enums";

import { EVENT_TOGGLE_TOGGLE_COMMAND } from "../const";

const props = defineProps<{
  nodeKey: string;
  open: boolean;
  hasContent: boolean;
}>();

const editor = useLexicalComposer();
const toggle = () =>
  editor.update(() => editor.dispatchCommand(EVENT_TOGGLE_TOGGLE_COMMAND, props.nodeKey), {
    tag: SKIP_DOM_SELECTION_TAG,
  });
</script>

<template>
  <div class="mt-[5px] mr-1 !inline-flex self-start align-middle">
    <Button
      :btn-style="ButtonStyle.CHIP"
      :icon-size="IconSize.XS"
      :icon-args="{
        class: ['transition-transform !h-3 !w-3', open ? 'rotate-90' : 'rotate-0', hasContent ? 'text-md' : 'text-vlt'],
      }"
      borderless
      :icon="ToggleSectionIcon"
      a11y-label="Toggle section"
      class="hover:!bg-lt"
      @mousedown.left.prevent
      @click.stop.prevent="toggle" />
  </div>
</template>
